@if (config().visible) {
  <div class="row" [formGroup]="formGroup">
    <mat-form-field>
      <mat-label [attr.for]="config().attrName">{{ config().label }}</mat-label>
      <input matInput [id]="config().attrName" formControlName="{{ config().attrName }}" />
    </mat-form-field>
  </div>
}
